import {
  StripeLineItem,
  StripeVolumePricingConfig,
} from '../../../../../shared/graphql/graphql';
import { convertStripeAmount } from '../../../../../shared/helpers/functions/number';
import { Tier } from '../../../../../shared/types/tiers';

export const getTiersFromPreview = (
  annualSubscriptionPriceId: string,
  previewLineItems: (StripeLineItem | null)[],
  volumePricing: StripeVolumePricingConfig[],
): Tier[] => {
  const annualSubscriptionLines = previewLineItems.filter(
    (lineItem) => lineItem?.priceId === annualSubscriptionPriceId,
  );

  return volumePricing.reduce((acc: Tier[], tier, tierIndex) => {
    const amount = annualSubscriptionLines[tierIndex]?.quantity ?? 0;
    const tierMin = tier.min ?? 0;
    const tierMax = tier.max ?? tierMin + amount;

    if (amount) {
      acc.push({
        min: tierMin,
        max: tierMax,
        amount,
        unitPrice: tier.price ?? 0,
        totalPrice: convertStripeAmount(
          annualSubscriptionLines[tierIndex]?.amount,
        ),
      });
    }

    return acc;
  }, []);
};
